import { useQuery } from '@tanstack/react-query';

import { GetTelemetryCreditItemsResponse, PurchasableItem } from '@/api/subscriptions/types';
import { RequestOptions, axios } from '@/common/axios';
import { QueryConfig } from '@/common/react-query';
import { APIResponse } from '@/common/types';

export const getPurchasableItems = async (options?: RequestOptions) => {
    const items = await axios.get<GetTelemetryCreditItemsResponse, APIResponse<PurchasableItem[]>>(
        '/api/v2/subscriptions/purchasable-items',
        options
    );
    return items.data;
};

type UsePurchasableItemsOptions = {
    config?: QueryConfig<typeof getPurchasableItems>;
};

export const usePurchasableItems = ({ config }: UsePurchasableItemsOptions = {}) => {
    return useQuery<PurchasableItem[]>({
        ...config,
        queryKey: ['get-purchasable-items'],
        queryFn: ({ signal }) => getPurchasableItems({ signal }),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
